module.exports = __webpack_public_path__ + "media/icons/envelope-solid-4ae3c7af.png";